import * as types from './mutation-types'

export default {
    [types.LOAD_CATEGORIES] (state, data) {
        state.categories = data.categories
    },
}

